var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgVideo = function SvgVideo(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    "data-width-14": 11,
    "data-width-16": 12,
    "data-width-20": 15,
    "data-width-24": 18,
    "data-width-28": 21,
    "data-width-32": 24,
    "data-width-36": 26,
    "data-width-40": 30,
    viewBox: "0 0 11.8 11.7",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M10.167 11.667H1.5a1.5 1.5 0 0 1-1.5-1.5V1.5A1.5 1.5 0 0 1 1.5 0h5.78a1.83 1.83 0 0 1 1.333.54l2.547 2.547a1.83 1.83 0 0 1 .54 1.333v5.747a1.5 1.5 0 0 1-1.533 1.5M1.5 1a.507.507 0 0 0-.5.5v8.667a.507.507 0 0 0 .5.5h8.667a.507.507 0 0 0 .5-.5v-5.78a.83.83 0 0 0-.247-.593L7.873 1.247A.84.84 0 0 0 7.28 1z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M3.381.5a.43.43 0 0 1 .43.43v4.475h4.045V.929a.43.43 0 1 1 .859 0v2.023h2.023a.43.43 0 1 1 0 .859H8.715v1.594h2.023a.43.43 0 1 1 0 .858H8.715v1.594h2.023a.43.43 0 1 1 0 .858H8.715v2.023a.43.43 0 1 1-.859 0V6.263H3.81v4.475a.43.43 0 1 1-.858 0V8.715H.93a.43.43 0 1 1 0-.858h2.023V6.263H.93a.43.43 0 1 1 0-.858h2.023V3.81H.93a.43.43 0 0 1 0-.859h2.023V.93A.43.43 0 0 1 3.382.5",
    clipRule: "evenodd"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgVideo);
export default ForwardRef;